/**
 * 이 파일의 목적: 모든 페이지에서 공용으로 사용되는 이벤트 핸들러 붙이기
 * 여기 안에서 Define을 쓰지 마시기 바랍니다.
 */
import track from '../common/tracking.lib';
import toast from '../util/toast';
import highlightingHelperInit from '../util/highlightingHelper';

highlightingHelperInit();

$(() => {
  track
    .find()
    .attachDisplayTracker()
    .attachClickTracker()
    .attachEventTracker()
    .end();

  // 도서 다운로드 버튼
  // download.lib.js로 옮기면 require download를 하기전에는 event handler
  // 자체가 불리지 않는 문제가 있어 아래와 같이 따로 분리함
  $('.js_download_book').click(function () {
    const bookId = $(this).data('book-id');
    const type = $(this).data('type');
    const seriesId = $(this).data('series-id');
    const isOnepun = $(this).data('is-onepun');
    import(/* webpackChunkName:"download.lib" */ '../common/download.lib').then(
      ({ default: download }) => {
        if (bookId !== undefined) {
          if (type !== undefined) {
            download.download([bookId], type);
          } else {
            download.trigger({
              bookIds: [bookId],
              seriesIds: [],
              preprocess: true,
              isOnepun,
            });
          }
        } else if (seriesId !== undefined) {
          download.trigger({
            bookIds: [],
            seriesIds: [seriesId],
            preprocess: true,
          });
        }
      },
    );

    return false;
  });

  // 앱 구매목록 이동 버튼
  $('.js_move_to_app_purchased_list').on('click', () => {
    import(/* webpackChunkName:"download.lib" */ '../common/download.lib').then(
      ({ default: download }) => {
        const $popupContainer = $('#select_app_type_popup_move_purchase_list');
        if ($popupContainer.length === 0) {
          download.launchAppPurchasedList(false);
          return;
        }
        if (Ridi.globals.isAndroid) {
          $popupContainer.show();

          $('.playstore_button')
            .off('click')
            .on('click', () => {
              $popupContainer.hide();
              download.launchAppPurchasedList(false);
              return false;
            });
          $('.onepun_button')
            .off('click')
            .on('click', () => {
              $popupContainer.hide();
              download.launchAppPurchasedList(true);
              return false;
            });
        } else {
          download.launchAppPurchasedList(false);
        }
      },
    );

    return false;
  });

  // "앱에서 다운로드 버튼" (하단 CTA)
  $('.js_download_book_for_app').on('click', async function () {
    const { default: download } = await import(
      /* webpackChunkName:"download.lib" */ '../common/download.lib',
    );
    const $popupContainer = $('#select_app_type_popup_with_download');
    if ($popupContainer.length === 0) {
      download.launchAppPurchasedList(false);
      return;
    }

    const handleDownload = (isOnepun = false) => {
      const { seriesId, id } = window.book;
      const { representativeBookIdInSetbook } = window.ComicEbookOnWebviewer;
      const isFree = $(this).data('type') === 'free';

      $popupContainer.hide();

      if (isFree) {
        download.download([id], 'free');
      } else {
        download.trigger({
          bookIds: seriesId ? [] : [representativeBookIdInSetbook || id],
          seriesIds: [seriesId],
          preprocess: true,
          isOnepun,
        });
      }
    };

    if (Ridi.globals.isAndroid) {
      $popupContainer.show();
      $('.playstore_button')
        .off('click')
        .on('click', () => handleDownload(false));
      $('.onepun_button')
        .off('click')
        .on('click', () => handleDownload(true));
    } else {
      handleDownload(false);
    }
  });
  // renderer 에서 페이지 로드 후 바로 노출하고픈 toast_msg 가 있을 경우
  // ex) 휴면계정 활성화 안내
  const { welcomeMessage } = Ridi.globals;
  if (welcomeMessage && welcomeMessage.length > 0) {
    toast.show(welcomeMessage, 5000);
  }
});



// WEBPACK FOOTER //
// ./ridi/ridi.common.js